interface Option {
  value: string | number;
  label: string;
}
interface Props {
  label: string;
  value: string | number;
  options: Option[];
  onChange: (v: string | number) => void;
  disabled?: boolean;
}

export function ChipsField({ label, value, options, onChange, disabled }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-[12px] font-medium text-[var(--text-secondary)]">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = opt.value === value;
          return (
            <button
              key={String(opt.value)}
              type="button"
              disabled={disabled}
              aria-pressed={active}
              onClick={() => onChange(opt.value)}
              className={[
                'h-10 px-4 rounded-xl text-[13px] font-semibold transition-all disabled:opacity-40',
                active
                  ? 'bg-[var(--primary)] text-[var(--primary-on)] shadow-[0_4px_14px_var(--primary-glow)]'
                  : 'bg-[var(--bg-elevated)] text-[var(--text-secondary)] hover:bg-[var(--bg-raised)] hover:text-[var(--text-primary)]',
              ].join(' ')}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
